module.exports = __webpack_public_path__ + "img/jin.2a66a7fc.png";